import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

// Function to get URL query parameter
function getQueryParam(name: string): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

// Function to determine API endpoint based on sender query parameter
function getApiEndpoint(): string {
   // if (process.env.NODE_ENV === 'development') {
    //    return 'https://localhost:7059';
   // }

    const sender = getQueryParam('sender');
    const endpointMap: Record<string, string> = {
        'mallorca': 'https://office.foodtoursmallorca.com',
        'ibiza': 'https://officeibiza.foodtoursbalearics.com'
    };

    return sender ? (endpointMap[sender] || '') : '';
}

const API_ENDPOINT = getApiEndpoint();
export const axiosInstance = axios.create({
    baseURL: API_ENDPOINT,
});

// Function to update base URL when query parameters change
export function updateBaseURL() {
    const newEndpoint = getApiEndpoint();
    axiosInstance.defaults.baseURL = newEndpoint;
}

axiosInstance.interceptors.request.use(async function (config) {
    try {
        // Update base URL to reflect current query parameters
        const currentEndpoint = getApiEndpoint();
        if (config.baseURL !== currentEndpoint) {
            config.baseURL = currentEndpoint;
        }
        
        if (!config.headers) {
        }
    } catch (error) {
    } finally {
        return config;
    }
});

axiosInstance.interceptors.response.use(
    function <T>(res: AxiosResponse<T>) {
        return new Promise((resolve, reject) => {
            return resolve(res);
        });
    },
    (error) => {
        throw {
            ...error,
            message: error?.response?.data?.message || error?.message || error,
        };
    }
);

export const request = {
    async get<T>(url: string, config?: AxiosRequestConfig | undefined) {
        return axiosInstance.get<T>(url, config).then((data) => data.data);
    },
    async post<T>(
        url: string,
        data?: any,
        config?: AxiosRequestConfig | undefined
    ) {
        return axiosInstance.post<T>(url, data, config).then((data) => data.data);
    },
};
